document.addEventListener('DOMContentLoaded', () => {

    // ============================================================
    // ELEMENTOS
    // ============================================================

    const section = document.querySelector(
        '.video__quem__somos__container'
    );

    if (!section) {
        console.error('[VIBECATS] Section não encontrada.');
        return;
    }

    const canvas = section.querySelector('.video-canvas');

    if (!canvas) {
        console.error('[VIBECATS] Canvas não encontrado.');
        return;
    }

    const ctx = canvas.getContext('2d');

    if (!ctx) {
        console.error('[VIBECATS] Contexto Canvas não disponível.');
        return;
    }

    if (typeof gsap === 'undefined') {
        console.error('[VIBECATS] GSAP não carregado.');
        return;
    }


    // ============================================================
    // TEXTOS
    // ============================================================

    const intro = section.querySelector('.text__intro');
    const text1 = section.querySelector('.text__1');
    const text2 = section.querySelector('.text__2');
    const text3 = section.querySelector('.text__3');
    const text4 = section.querySelector('.text__4');
    const text5 = section.querySelector('.text__5');
    const text6 = section.querySelector('.text__6');
    const text7 = section.querySelector('.text__7');
    const text8 = section.querySelector('.text__8');
    const text9 = section.querySelector('.text__9');
    const text10 = section.querySelector('.text__10');
    const text11 = section.querySelector('.text__11');
    const text12 = section.querySelector('.text__12');
    const slogan = section.querySelector('.text__slogan');


    const allTexts = [
        intro,
        text1,
        text2,
        text3,
        text4,
        text5,
        text6,
        text7,
        text8,
        text9,
        text10,
        text11,
        text12,
        slogan
    ].filter(Boolean);


    // ============================================================
    // CONFIGURAÇÕES
    // ============================================================

    const FRAME_PATH =
        `${VIBECATS.themeUri}/dist/images/frames-quem-somos/`;

    const FPS = 20;

    const TOTAL_FRAMES = 631;

    const VIDEO_DURATION =
        TOTAL_FRAMES / FPS;


    // ============================================================
    // SCROLL
    // ============================================================

    const INTRO_SCROLL = 300;

    const SCROLL_PER_SECOND = 200;

    const AFTER_VIDEO_GAP = 100;


    // ============================================================
    // CANVAS
    // ============================================================

    const MAX_WIDTH = 1920;

    const MAX_HEIGHT = 1080;


    // ============================================================
    // ESTADO
    // ============================================================

    const frames = [];

    let framesLoaded = false;

    let currentFrame = -1;

    let canvasVisible = false;

    let videoStarted = false;

    let ticking = false;

    let lastScroll = null;


    /*
     * MUITO IMPORTANTE
     *
     * Guarda a posição de scroll no momento em que
     * o usuário realmente começa a rolar a section.
     */

    let animationStartScroll = null;


    /*
     * Indica que o usuário já começou a rolar
     * para baixo dentro da animação.
     */

    let userStartedScrolling = false;


    // ============================================================
    // TIMELINE DO VÍDEO
    // ============================================================

    const videoTimeline = [

        {
            element: text1,
            start: 0,
            end: 4
        },

        {
            element: text2,
            start: 5,
            end: 8
        },

        {
            element: text3,
            start: 9,
            end: 12
        },

        {
            element: text4,
            start: 14,
            end: 18
        },

        {
            element: text5,
            start: 19,
            end: 23
        },

        {
            element: text6,
            start: 24,
            end: 26
        }

    ].filter(item => item.element);


    // ============================================================
    // TIMELINE DEPOIS DO VÍDEO
    // ============================================================

    const afterVideoTimeline = [

        {
            element: text7,
            start: 0,
            end: 4
        },

        {
            element: text8,
            start: 5,
            end: 9
        },

        {
            element: text9,
            start: 10,
            end: 14
        },

        {
            element: text10,
            start: 15,
            end: 19
        },

        {
            element: text11,
            start: 20,
            end: 24
        },

        {
            element: text12,
            start: 25,
            end: 29
        },

        {
            element: slogan,
            start: 30,
            end: 34
        }

    ].filter(item => item.element);


    // ============================================================
    // REMOVE TODAS AS CLASSES ACTIVE
    // ============================================================

    function removeAllActive() {

        allTexts.forEach(element => {

            element.classList.remove('active');

        });
    }


    // ============================================================
    // ATIVA TEXTO
    // ============================================================

    function activateText(element) {

        if (!element) {
            return;
        }

        allTexts.forEach(text => {

            text.classList.remove('active');

        });

        element.classList.add('active');
    }


    // ============================================================
    // FORÇA INTRO
    // ============================================================

    function forceIntro() {

        /*
         * Cancela qualquer animação do canvas.
         */

        gsap.killTweensOf(canvas);


        /*
         * Remove TODOS os textos.
         */

        removeAllActive();


        /*
         * Ativa SOMENTE a intro.
         */

        if (intro) {
            intro.classList.add('active');
        }


        /*
         * Esconde canvas.
         */

        canvasVisible = false;

        gsap.set(canvas, {
            opacity: 0,
            visibility: 'hidden'
        });


        /*
         * Volta para primeiro frame.
         */

        if (
            framesLoaded &&
            frames[0]
        ) {

            drawFrame(0);

        }


        /*
         * Marca vídeo como parado.
         */

        videoStarted = false;
    }


    // ============================================================
    // MOSTRA CANVAS
    // ============================================================

    function showCanvas() {

        if (canvasVisible) {
            return;
        }

        canvasVisible = true;

        gsap.killTweensOf(canvas);

        gsap.fromTo(

            canvas,

            {
                opacity: 0,
                visibility: 'hidden'
            },

            {
                opacity: 1,
                visibility: 'visible',
                duration: 0.8,
                ease: 'power2.out',
                overwrite: true
            }

        );
    }


    // ============================================================
    // ESCONDE CANVAS
    // ============================================================

    function hideCanvas() {

        canvasVisible = false;

        gsap.killTweensOf(canvas);

        gsap.set(canvas, {
            opacity: 0,
            visibility: 'hidden'
        });
    }


    // ============================================================
    // RESIZE CANVAS
    // ============================================================

    function resizeCanvas() {

        const dpr =
            Math.min(
                window.devicePixelRatio || 1,
                2
            );


        let width =
            Math.min(
                window.innerWidth,
                MAX_WIDTH
            );


        let height =
            Math.min(
                window.innerHeight,
                MAX_HEIGHT
            );


        const ratio = 16 / 9;


        if (
            width / height > ratio
        ) {

            width =
                height * ratio;

        } else {

            height =
                width / ratio;

        }


        width = Math.round(width);

        height = Math.round(height);


        canvas.width =
            Math.round(
                width * dpr
            );


        canvas.height =
            Math.round(
                height * dpr
            );


        canvas.style.width =
            `${width}px`;

        canvas.style.height =
            `${height}px`;


        canvas.style.position =
            'fixed';

        canvas.style.left =
            '50%';

        canvas.style.top =
            '50%';

        canvas.style.transform =
            'translate(-50%, -50%)';

        canvas.style.margin =
            '0';


        ctx.setTransform(
            dpr,
            0,
            0,
            dpr,
            0,
            0
        );


        if (
            currentFrame >= 0 &&
            frames[currentFrame]
        ) {

            drawFrame(
                currentFrame
            );

        }
    }


    // ============================================================
    // DESENHA FRAME
    // ============================================================

    function drawFrame(index) {

        const image =
            frames[index];

        if (!image) {
            return;
        }


        const width =
            parseFloat(
                canvas.style.width
            );


        const height =
            parseFloat(
                canvas.style.height
            );


        if (
            !width ||
            !height
        ) {
            return;
        }


        ctx.clearRect(
            0,
            0,
            width,
            height
        );


        /*
         * A imagem ocupa exatamente todo o canvas.
         */

        ctx.drawImage(
            image,
            0,
            0,
            width,
            height
        );


        currentFrame = index;
    }


    // ============================================================
    // PRELOAD
    // ============================================================

    function preloadFrames() {

        const promises = [];


        for (
            let i = 0;
            i < TOTAL_FRAMES;
            i++
        ) {

            promises.push(

                new Promise(
                    (
                        resolve,
                        reject
                    ) => {

                        const image =
                            new Image();


                        const number =
                            String(
                                i + 1
                            ).padStart(
                                4,
                                '0'
                            );


                        image.src =
                            `${FRAME_PATH}frame_${number}.webp`;


                        image.onload =
                            () => {

                                frames[i] =
                                    image;

                                resolve();

                            };


                        image.onerror =
                            () => {

                                reject(
                                    new Error(
                                        `Erro ao carregar frame_${number}.webp`
                                    )
                                );

                            };

                    }
                )

            );
        }


        return Promise.all(
            promises
        );
    }


    // ============================================================
    // TEMPO -> FRAME
    // ============================================================

    function setVideoTime(time) {

        if (!framesLoaded) {
            return;
        }


        time =
            Math.max(
                0,
                Math.min(
                    VIDEO_DURATION,
                    time
                )
            );


        let frame =
            Math.floor(
                time * FPS
            );


        frame =
            Math.max(
                0,
                Math.min(
                    TOTAL_FRAMES - 1,
                    frame
                )
            );


        if (
            frame === currentFrame
        ) {
            return;
        }


        drawFrame(frame);
    }


    // ============================================================
    // TEXTO DO VÍDEO
    // ============================================================

    function updateVideoText(time) {

        const item =
            videoTimeline.find(
                item =>
                    time >= item.start &&
                    time < item.end
            );


        if (item) {

            activateText(
                item.element
            );

        } else {

            removeAllActive();

        }
    }


    // ============================================================
    // TEXTO FINAL
    // ============================================================

    function updateAfterVideoText(time) {

        const item =
            afterVideoTimeline.find(
                item =>
                    time >= item.start &&
                    time < item.end
            );


        if (item) {

            activateText(
                item.element
            );

        } else {

            removeAllActive();

        }
    }


    // ============================================================
    // ALTURA DA SECTION
    // ============================================================

    function updateSectionHeight() {

        const last =
            afterVideoTimeline[
                afterVideoTimeline.length - 1
            ];


        const afterEnd =
            last
                ? last.end
                : 0;


        const videoScroll =
            VIDEO_DURATION *
            SCROLL_PER_SECOND;


        const afterScroll =
            afterEnd *
            SCROLL_PER_SECOND;


        const totalScroll =

            INTRO_SCROLL +
            videoScroll +
            AFTER_VIDEO_GAP +
            afterScroll;


        section.style.height =
            `${totalScroll + window.innerHeight}px`;
    }


    // ============================================================
    // ATUALIZA ANIMAÇÃO
    // ============================================================

    function updateAnimation(scrollPosition) {

        /*
         * ========================================================
         * IMPORTANTE
         *
         * Se ainda não houve uma rolagem real para baixo,
         * NÃO inicia absolutamente nada.
         * ========================================================
         */

        if (
            !userStartedScrolling
        ) {

            forceIntro();

            return;
        }


        /*
         * ========================================================
         * QUANTO O USUÁRIO ROLou DESDE O INÍCIO DA ANIMAÇÃO
         * ========================================================
         */

        const animationScroll =
            scrollPosition -
            animationStartScroll;


        // ========================================================
        // VOLTOU PARA TRÁS
        // ========================================================

        if (
            animationScroll <= 0
        ) {

            /*
             * Reset completo.
             */

            forceIntro();

            return;
        }


        // ========================================================
        // PRIMEIROS 300PX
        // ========================================================

        if (
            animationScroll <=
            INTRO_SCROLL
        ) {

            /*
             * Durante os primeiros 300px:
             *
             * INTRO ATIVA
             * CANVAS OCULTO
             * FRAME 1
             */

            forceIntro();

            return;
        }


        // ========================================================
        // FRAMES NÃO CARREGADOS
        // ========================================================

        if (!framesLoaded) {
            return;
        }


        // ========================================================
        // INÍCIO DO VÍDEO
        // ========================================================

        if (!videoStarted) {

            videoStarted = true;

            removeAllActive();

            showCanvas();
        }


        // ========================================================
        // SCROLL DO VÍDEO
        // ========================================================

        const videoScroll =
            animationScroll -
            INTRO_SCROLL;


        const totalVideoScroll =
            VIDEO_DURATION *
            SCROLL_PER_SECOND;


        // ========================================================
        // VÍDEO
        // ========================================================

        if (
            videoScroll <
            totalVideoScroll
        ) {

            showCanvas();


            const videoTime =
                videoScroll /
                SCROLL_PER_SECOND;


            setVideoTime(
                videoTime
            );


            updateVideoText(
                videoTime
            );


            return;
        }


        // ========================================================
        // FINAL DO VÍDEO
        // ========================================================

        hideCanvas();


        const afterVideoScroll =

            videoScroll -
            totalVideoScroll;


        // ========================================================
        // GAP
        // ========================================================

        if (
            afterVideoScroll <
            AFTER_VIDEO_GAP
        ) {

            removeAllActive();

            return;
        }


        // ========================================================
        // TEXTOS FINAIS
        // ========================================================

        const afterVideoTime =

            (
                afterVideoScroll -
                AFTER_VIDEO_GAP
            ) /
            SCROLL_PER_SECOND;


        updateAfterVideoText(
            afterVideoTime
        );
    }


    // ============================================================
    // PROCESSA SCROLL
    // ============================================================

    function processScroll(scrollPosition) {

        if (
            typeof scrollPosition !==
            'number'
        ) {
            return;
        }


        /*
         * Se não houve movimento,
         * não faz absolutamente nada.
         */

        if (
            lastScroll === null
        ) {

            lastScroll =
                scrollPosition;

            return;
        }


        /*
         * Detecta movimento.
         */

        const delta =
            scrollPosition -
            lastScroll;


        /*
         * Atualiza último scroll.
         */

        lastScroll =
            scrollPosition;


        // ========================================================
        // USUÁRIO COMEÇOU A ROLAR PARA BAIXO
        // ========================================================

        if (
            delta > 0 &&
            !userStartedScrolling
        ) {

            /*
             * IMPORTANTE:
             *
             * O ponto inicial é o scroll ATUAL.
             *
             * A partir daqui começam os 300px.
             */

            userStartedScrolling = true;

            animationStartScroll =
                scrollPosition;


            /*
             * Ainda estamos no começo.
             */

            forceIntro();

            return;
        }


        // ========================================================
        // USUÁRIO VOLTOU PARA TRÁS
        // ========================================================

        if (
            delta < 0
        ) {

            /*
             * Se voltou até o ponto inicial,
             * reseta completamente.
             */

            if (
                scrollPosition <=
                animationStartScroll
            ) {

                userStartedScrolling = false;

                animationStartScroll =
                    null;

                forceIntro();

                return;
            }
        }


        /*
         * Atualiza animação.
         */

        updateAnimation(
            scrollPosition
        );
    }


    // ============================================================
    // INICIALIZAÇÃO
    // ============================================================

    resizeCanvas();

    updateSectionHeight();


    /*
     * PRIMEIRO ESTADO:
     *
     * Sempre INTRO.
     *
     * Nunca inicia animação.
     */

    forceIntro();


    // ============================================================
    // PRELOAD
    // ============================================================

    preloadFrames()

        .then(() => {

            framesLoaded = true;


            console.log(
                `[VIBECATS] ${TOTAL_FRAMES} frames carregados.`
            );


            /*
             * Primeiro frame.
             */

            drawFrame(0);


            /*
             * NÃO chama updateAnimation.
             * NÃO chama processScroll.
             * NÃO inicia vídeo.
             */

            forceIntro();

        })

        .catch(error => {

            console.error(
                '[VIBECATS] Erro no preload:',
                error
            );

        });


    // ============================================================
    // LENIS
    // ============================================================

    const hasLenis =

        typeof lenis !== 'undefined' &&
        lenis &&
        typeof lenis.on === 'function';


    if (hasLenis) {

        /*
         * SOMENTE LENIS.
         */

        lenis.on(
            'scroll',
            ({ scroll }) => {

                processScroll(
                    scroll
                );

            }
        );


        console.log(
            '[VIBECATS] ✓ Usando Lenis.'
        );

    } else {

        /*
         * SOMENTE scroll nativo.
         */

        window.addEventListener(
            'scroll',
            () => {

                if (ticking) {
                    return;
                }


                ticking = true;


                requestAnimationFrame(
                    () => {

                        processScroll(
                            window.scrollY
                        );


                        ticking = false;

                    }
                );

            },
            {
                passive: true
            }
        );


        console.log(
            '[VIBECATS] ✓ Usando scroll nativo.'
        );
    }


    // ============================================================
    // RESIZE
    // ============================================================

    window.addEventListener(
        'resize',
        () => {

            resizeCanvas();

            updateSectionHeight();

            /*
             * NÃO iniciamos a animação aqui.
             */

        }
    );


    // ============================================================
    // DEBUG
    // ============================================================

    /*
    window.addEventListener('scroll', () => {

        console.log({
            scroll: window.scrollY,
            started: userStartedScrolling,
            animationStart: animationStartScroll,
            relative: animationStartScroll !== null
                ? window.scrollY - animationStartScroll
                : 0,
            intro: intro
                ? intro.classList.contains('active')
                : false,
            text1: text1
                ? text1.classList.contains('active')
                : false,
            canvasVisible
        });

    });
    */


});